// reactstrap components
import { Container, Col, Row, Button } from "reactstrap";

import React from "react";
import ParticleBackground from "components/Particles";

function LandingPageHeader({ home }) {
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;

  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (document.documentElement.scrollTop > 50 || document.body.scrollTop > 50) {
      } else if (document.documentElement.scrollTop < 300 || document.body.scrollTop < 300) {
      }
    };

    window.addEventListener("scroll", updateNavbarColor);

    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });

  return (
    <div
      style={{
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background image */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: `url(${require(
            `assets/images/${size ? "1920x1080.png" : "1920x10801.png"}`,
          )}), url(${require(`assets/images/${size ? "background1.png" : "background1.png"}`)})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover",
          zIndex: 0,
        }}
      />

      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1,
          pointerEvents: "none",
        }}
      />

      <div
        style={{
          position: "relative",
          zIndex: 2,
          paddingTop: "5rem",
          overflow: "hidden",
          backgroundColor: "transparent",
        }}
        className="page-header"
      >
        {/* <div className="overlay-primary"></div> */}

        <Container style={{ marginTop: !size && "-1rem" }}>
          <Row className="justify-content-center">
            <Col md={6} xs={12}>
              <img
                src={require(`assets/images/logo/Geomatix.png`)}
                style={{ maxWidth: size ? "250px" : 150 }}
                width="100%"
                alt="dt22"
              />
              <h5 className="text-700 text-white mt-2" style={{ fontSize: size ? 16 : 10 }}>
                Presents
              </h5>
              <img
                src={require(`assets/images/logo/elogo.png`)}
                style={{ maxWidth: size ? "400px" : 320 }}
                width="100%"
                alt="dt22"
              />

              <h1
                className="text-700 text-white mt-3"
                style={{
                  fontSize: size ? "2rem" : "1.25rem",
                  // width: size ? "480px" : "330px",
                }}
              >
                HILTON CAIRO HELIOPOLIS, CAIRO, EGYPT
              </h1>
              <div className="d-flex mt-2">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "20px",
                  }}
                >
                  <h1
                    className="text-700 text-white m-0 border-right pr-2"
                    style={{
                      fontSize: "4rem",
                    }}
                  >
                    22
                  </h1>
                  <h1
                    className="text-700 text-white m-0 pl-2"
                    style={{
                      fontSize: "1.5rem",
                    }}
                  >
                    APRIL
                    <br />
                    2026
                  </h1>
                </div>
                <div style={{ padding: "2px", alignSelf: "center" }}>
                  <h1
                    className="text-700 text-white m-0"
                    style={{
                      fontSize: size ? "1.5rem" : "1rem",
                    }}
                  >
                    CONFERENCE <br />& EXHIBITION
                  </h1>
                </div>
              </div>

              <br />

              <div className="container-fluid row mt-1">
                <Col lg={12} className="px-0">
                  <Button
                    href="/register"
                    className="rounded-0 navbar-item-custom text-400 text-white px-4"
                    color="info"
                    size="lg"
                    target="_blank"
                    style={{ background: "#ceb739" }}
                    rel="noopener noreferrer"
                  >
                    <span
                      style={{
                        color: "#fff",
                        textTransform: "none",
                        fontSize: "20px",
                        fontWeight: 700,
                      }}
                    >
                      REGISTER NOW
                    </span>
                  </Button>{" "}
                  <Button
                    href="/agenda"
                    className="rounded-0 navbar-item-custom text-400 text-white px-4"
                    color="primary"
                    size="lg"
                    target="_blank"
                    style={{ background: "#ceb739" }}
                    rel="noopener noreferrer"
                  >
                    <span
                      style={{
                        color: "#fff",
                        textTransform: "none",
                        fontSize: "20px",
                        fontWeight: 700,
                      }}
                    >
                      VIEW AGENDA
                    </span>
                  </Button>
                </Col>
              </div>
            </Col>

            {/* <Col md={6} xs={12} className="mt-4"></Col> */}
          </Row>
        </Container>
        <ParticleBackground />
      </div>
    </div>
  );
}

export default LandingPageHeader;
